import React from 'react'

const Search = (props)=>{
  //console.log('propsy z searach',props);
  return (
    <div>
      <input
        onChange={props.inputHandler}
        type="text"
        placeholder="szukaj"
        className="vt14 search__input"
      />
      <p className="search-p">szukanie zaawansowane</p>
      {props.data.single_list_image && (
        <img src={props.data.single_list_image} />
      )}
    </div>
  )
}
export default Search;



// WEBPACK FOOTER //
// ./src/Components/Elements/Search/Search.js